import * as React from "react";
import './radioFieldListControl.component.scss';
import {RadioFieldListControlComponentProps} from "../../types/types";

export const RadioFieldListControlComponent = ( {name, theme, onChange, options}: RadioFieldListControlComponentProps ) => {
    if ( !options ) {
        return <React.Fragment/>
    }

    return (<div className={`radio-field-list ${theme} d-flex justify-content-between flex-wrap w-100 mb-3`}>
        {options.map( ( option ) => {
            const icon = typeof option.imageUrl === "string" ? <img className="card-img-top icon" src={option.imageUrl} alt="Icon"/> :
                <span className="card-img-top d-flex justify-content-center align-items-center w-100">{option.imageUrl}</span>;

            return (<div className={`card radio-field-list-item ${option.selected ? " selected" : ""}`} onClick={( e ) => onChange(
                option.value )} key={option.key}>
                {icon}
                <div className="card-body pt-0">
                    <p className="card-text">
                        {option.text}
                    </p>
                </div>
            </div>)
        } )}
    </div>);
};

